/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PractitionerBaseService } from '../practitioner-base-service';
import { PractitionerApiConfiguration } from '../practitioner-api-configuration';
import { PractitionerStrictHttpResponse } from '../practitioner-strict-http-response';

import { adminOrganizationLocationsOrganizationFhirIdGet } from '../fn/admin/admin-organization-locations-organization-fhir-id-get';
import { AdminOrganizationLocationsOrganizationFhirIdGet$Params } from '../fn/admin/admin-organization-locations-organization-fhir-id-get';
import { adminPersonIdDelete } from '../fn/admin/admin-person-id-delete';
import { AdminPersonIdDelete$Params } from '../fn/admin/admin-person-id-delete';
import { adminPersonIdDeleteRoleRoleIdDelete } from '../fn/admin/admin-person-id-delete-role-role-id-delete';
import { AdminPersonIdDeleteRoleRoleIdDelete$Params } from '../fn/admin/admin-person-id-delete-role-role-id-delete';
import { adminPersonIdGet } from '../fn/admin/admin-person-id-get';
import { AdminPersonIdGet$Params } from '../fn/admin/admin-person-id-get';
import { adminPersonIdGetRolesGet } from '../fn/admin/admin-person-id-get-roles-get';
import { AdminPersonIdGetRolesGet$Params } from '../fn/admin/admin-person-id-get-roles-get';
import { adminPersonIdPhotoPost } from '../fn/admin/admin-person-id-photo-post';
import { AdminPersonIdPhotoPost$Params } from '../fn/admin/admin-person-id-photo-post';
import { adminPersonIdSaveRolesPost } from '../fn/admin/admin-person-id-save-roles-post';
import { AdminPersonIdSaveRolesPost$Params } from '../fn/admin/admin-person-id-save-roles-post';
import { adminPost } from '../fn/admin/admin-post';
import { AdminPost$Params } from '../fn/admin/admin-post';
import { adminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet } from '../fn/admin/admin-practitioner-role-fhir-id-get-practitioner-role-async-get';
import { AdminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet$Params } from '../fn/admin/admin-practitioner-role-fhir-id-get-practitioner-role-async-get';
import { adminSearchPost } from '../fn/admin/admin-search-post';
import { AdminSearchPost$Params } from '../fn/admin/admin-search-post';
import { OrganizationLocationModel } from '../models/organization-location-model';
import { PractitionerAdminModel } from '../models/practitioner-admin-model';
import { PractitionerRoleModel } from '../models/practitioner-role-model';
import { PractitionerSearchResultModel } from '../models/practitioner-search-result-model';

@Injectable({ providedIn: 'root' })
export class PRACAdminService extends PractitionerBaseService {
  constructor(config: PractitionerApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminSearchPost()` */
  static readonly AdminSearchPostPath = '/Admin/Search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminSearchPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminSearchPost$Response(params?: AdminSearchPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<Array<PractitionerSearchResultModel>>> {
    return adminSearchPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminSearchPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminSearchPost(params?: AdminSearchPost$Params, context?: HttpContext): Observable<Array<PractitionerSearchResultModel>> {
    return this.adminSearchPost$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<Array<PractitionerSearchResultModel>>): Array<PractitionerSearchResultModel> => r.body)
    );
  }

  /** Path part for operation `adminPersonIdGet()` */
  static readonly AdminPersonIdGetPath = '/Admin/{personId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminPersonIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminPersonIdGet$Response(params: AdminPersonIdGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<PractitionerAdminModel>> {
    return adminPersonIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminPersonIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminPersonIdGet(params: AdminPersonIdGet$Params, context?: HttpContext): Observable<PractitionerAdminModel> {
    return this.adminPersonIdGet$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<PractitionerAdminModel>): PractitionerAdminModel => r.body)
    );
  }

  /** Path part for operation `adminPersonIdDelete()` */
  static readonly AdminPersonIdDeletePath = '/Admin/{personId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminPersonIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminPersonIdDelete$Response(params: AdminPersonIdDelete$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<void>> {
    return adminPersonIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminPersonIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminPersonIdDelete(params: AdminPersonIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.adminPersonIdDelete$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminPost()` */
  static readonly AdminPostPath = '/Admin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminPost$Response(params?: AdminPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<string>> {
    return adminPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminPost(params?: AdminPost$Params, context?: HttpContext): Observable<string> {
    return this.adminPost$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `adminPersonIdGetRolesGet()` */
  static readonly AdminPersonIdGetRolesGetPath = '/Admin/{personId}/GetRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminPersonIdGetRolesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminPersonIdGetRolesGet$Response(params: AdminPersonIdGetRolesGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<Array<PractitionerRoleModel>>> {
    return adminPersonIdGetRolesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminPersonIdGetRolesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminPersonIdGetRolesGet(params: AdminPersonIdGetRolesGet$Params, context?: HttpContext): Observable<Array<PractitionerRoleModel>> {
    return this.adminPersonIdGetRolesGet$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<Array<PractitionerRoleModel>>): Array<PractitionerRoleModel> => r.body)
    );
  }

  /** Path part for operation `adminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet()` */
  static readonly AdminPractitionerRoleFhirIdGetPractitionerRoleAsyncGetPath = '/Admin/{practitionerRoleFhirId}/GetPractitionerRoleAsync';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet$Response(params: AdminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<PractitionerRoleModel>> {
    return adminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet(params: AdminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet$Params, context?: HttpContext): Observable<PractitionerRoleModel> {
    return this.adminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<PractitionerRoleModel>): PractitionerRoleModel => r.body)
    );
  }

  /** Path part for operation `adminPersonIdSaveRolesPost()` */
  static readonly AdminPersonIdSaveRolesPostPath = '/Admin/{personId}/SaveRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminPersonIdSaveRolesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminPersonIdSaveRolesPost$Response(params: AdminPersonIdSaveRolesPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<string>> {
    return adminPersonIdSaveRolesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminPersonIdSaveRolesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminPersonIdSaveRolesPost(params: AdminPersonIdSaveRolesPost$Params, context?: HttpContext): Observable<string> {
    return this.adminPersonIdSaveRolesPost$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `adminPersonIdDeleteRoleRoleIdDelete()` */
  static readonly AdminPersonIdDeleteRoleRoleIdDeletePath = '/Admin/{personId}/DeleteRole/{roleId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminPersonIdDeleteRoleRoleIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminPersonIdDeleteRoleRoleIdDelete$Response(params: AdminPersonIdDeleteRoleRoleIdDelete$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<void>> {
    return adminPersonIdDeleteRoleRoleIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminPersonIdDeleteRoleRoleIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminPersonIdDeleteRoleRoleIdDelete(params: AdminPersonIdDeleteRoleRoleIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.adminPersonIdDeleteRoleRoleIdDelete$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminOrganizationLocationsOrganizationFhirIdGet()` */
  static readonly AdminOrganizationLocationsOrganizationFhirIdGetPath = '/Admin/OrganizationLocations/{organizationFhirId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminOrganizationLocationsOrganizationFhirIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminOrganizationLocationsOrganizationFhirIdGet$Response(params: AdminOrganizationLocationsOrganizationFhirIdGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<Array<OrganizationLocationModel>>> {
    return adminOrganizationLocationsOrganizationFhirIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminOrganizationLocationsOrganizationFhirIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminOrganizationLocationsOrganizationFhirIdGet(params: AdminOrganizationLocationsOrganizationFhirIdGet$Params, context?: HttpContext): Observable<Array<OrganizationLocationModel>> {
    return this.adminOrganizationLocationsOrganizationFhirIdGet$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<Array<OrganizationLocationModel>>): Array<OrganizationLocationModel> => r.body)
    );
  }

  /** Path part for operation `adminPersonIdPhotoPost()` */
  static readonly AdminPersonIdPhotoPostPath = '/Admin/{personId}/Photo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminPersonIdPhotoPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminPersonIdPhotoPost$Response(params: AdminPersonIdPhotoPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<string>> {
    return adminPersonIdPhotoPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminPersonIdPhotoPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminPersonIdPhotoPost(params: AdminPersonIdPhotoPost$Params, context?: HttpContext): Observable<string> {
    return this.adminPersonIdPhotoPost$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<string>): string => r.body)
    );
  }

}
